import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { dict } = useLanguage();
  const f = dict.footer;
  const services = dict.services.items;

  const footerLinks = {
    company: [{ name: f.aboutUs, href: '#about' }],
    services: [
      { name: services[0].title, href: '#services' },
      { name: services[1].title, href: '#services' },
      { name: services[2].title, href: '#services' },
      { name: services[5].title, href: '#services' },
    ],
    legal: [
      { name: f.privacy, href: '#' },
      { name: f.terms, href: '#' },
      { name: f.cookies, href: '#' },
    ],
  };

  return (
    <footer className="bg-gray-800 text-gray-300">
      <div className="container mx-auto px-4 pt-12 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h4 className="text-white font-bold mb-4">{f.company}</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="hover:text-blue-400 transition-colors duration-300">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">{f.services}</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="hover:text-blue-400 transition-colors duration-300">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">{f.legal}</h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="hover:text-blue-400 transition-colors duration-300">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-700">
          <div className="flex items-center mb-4 md:mb-0">
            <img
              src="https://primetaxonline.com/img/logos/techrabbitlogo.jpeg"
              alt="Tech Rabbit Logo"
              className="h-8 w-auto mr-2 rounded"
            />
          </div>

          <div className="text-sm">
            &copy; {currentYear} TechRabbit. {f.rights}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
